import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {GetAllStaff} from '../../../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import {
  ProfileDetailData,
  WhiteLabelProfileData,
} from '../../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  RateCardList: [],
}

export const FeGetPriceRuleList: any = createAsyncThunk(
  '/FeGetPriceRuleList',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/feGetPriceRuleList/${data?.accountId}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetPriceRuleList: any = createAsyncThunk(
  '/GetPriceRuleList',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/GetPriceRuleList/${data?.accountId}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const PriceRuleCreateBySuperAdmin: any = createAsyncThunk(
  '/PriceRuleCreateBySuperAdmin',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .post(`${API_URL}admin/createPriceRule`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetPriceRuleList({accountId: data.accountId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const UpdatePriceRateSuperAdmin: any = createAsyncThunk(
  '/UpdatePriceRateSuperAdmin',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/updatePriceRule/${data?.id}`, data?.priceData, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetPriceRuleList({accountId: data?.priceData?.accountId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const UpdateCommisionRateSuperAdmin: any = createAsyncThunk(
  '/UpdateCommisionRateSuperAdmin',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/updateCommission`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetAllStaff())
    thunkApi.dispatch(ProfileDetailData(data?.userId))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const UpdateWhiteLabelCommisionRateSuperAdmin: any = createAsyncThunk(
  '/UpdateWhiteLabelCommisionRateSuperAdmin',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/updateCommission`, data.commission, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetAllStaff())
    thunkApi.dispatch(WhiteLabelProfileData(data?.id))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const DeletePriceRateSuperAdmin: any = createAsyncThunk(
  '/UpdatePriceRateSuperAdmin',
  async (data: any, thunkApi) => {
    const response: any = await axios
      .put(`${API_URL}admin/deletePriceRule/${data?.id}`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => toast.success(res?.data?.message))
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetPriceRuleList({accountId: data?.accId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

///////////////////SUPER ADMIN UPDATE DISCOUNT FOR PATICULAR STAFF /////////////////////////////

const PriceRules = createSlice({
  name: 'PriceRules',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [GetPriceRuleList.fulfilled]: (state, {payload}) => {
      return {...state, RateCardList: payload.data}
    },
    [FeGetPriceRuleList.fulfilled]: (state, {payload}) => {
      return {...state, RateCardList: payload.data}
    },
  },
})

export default PriceRules.reducer
